import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import type { HTMLAttributes } from 'react';

type IconProps = Partial<CustomIconComponentProps> & HTMLAttributes<HTMLSpanElement>;

export const FilterIcon = (props: Partial<CustomIconComponentProps>) => {
  const FilterSVG = () => {
    return (
      <svg
        width='40'
        height='40'
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_761_49391)'>
          <rect width='40' height='40' rx='20' fill='white' />
          <rect width='40' height='40' rx='20' fill='#F3F4F6' />
          <path
            d='M16.2505 15.5H23.7505L19.993 20.225L16.2505 15.5ZM14.188 15.2075C15.703 17.15 18.5005 20.75 18.5005 20.75V25.25C18.5005 25.6625 18.838 26 19.2505 26H20.7505C21.163 26 21.5005 25.6625 21.5005 25.25V20.75C21.5005 20.75 24.2905 17.15 25.8055 15.2075C26.188 14.7125 25.8355 14 25.213 14H14.7805C14.158 14 13.8055 14.7125 14.188 15.2075Z'
            fill='#696F88'
          />
        </g>
        <defs>
          <clipPath id='clip0_761_49391'>
            <rect width='40' height='40' rx='20' fill='white' />
          </clipPath>
        </defs>
      </svg>
    );
  };
  return <Icon component={FilterSVG} {...props} />;
};

export const EditPencilsIcon = (props: Partial<CustomIconComponentProps>) => {
  const EditPencilsSVG = () => {
    return (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='icon-left-24px'>
          <path
            id='save_alt'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15.59 10.09L13 12.67V3H11V12.67L8.41 10.09L7 11.5L12 16.5L17 11.5L15.59 10.09ZM19 19V12H21V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V12H5V19H19Z'
            fill='#696F88'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={EditPencilsSVG} {...props} />;
};
export const CopyPencilsIcon = (props: Partial<CustomIconComponentProps>) => {
  const CopyPencilsSVG = () => {
    return (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='icon-left-24px'>
          <path
            id='copy'
            d='M9 18C8.45 18 7.97917 17.8042 7.5875 17.4125C7.19583 17.0208 7 16.55 7 16V4C7 3.45 7.19583 2.97917 7.5875 2.5875C7.97917 2.19583 8.45 2 9 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H9ZM9 16H18V4H9V16ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6H5V20H16V22H5Z'
            fill='#696F88'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={CopyPencilsSVG} {...props} />;
};

export const PencilsIcon = (props: Partial<CustomIconComponentProps>) => {
  const PencilsSVG = () => {
    return (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='icon-left-24px'>
          <path
            id='edit'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M17.658 3C17.408 3 17.148 3.1 16.958 3.29L15.128 5.12L18.878 8.87L20.708 7.04C21.098 6.65 21.098 6.02 20.708 5.63L18.368 3.29C18.168 3.09 17.918 3 17.658 3ZM14.058 9.02L14.978 9.94L5.91805 19H4.99805V18.08L14.058 9.02ZM2.99805 17.2514L14.058 6.19141L17.808 9.94141L6.74805 21.0014H2.99805V17.2514Z'
            fill='#696F88'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={PencilsSVG} {...props} />;
};

export const OFFIcon = (props: Partial<CustomIconComponentProps>) => {
  const OFFSVG = () => {
    return (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='icon-left-24px'>
          <path
            id='sync_disabled'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3.32031 4.73031L4.73031 3.32031L20.6803 19.2703L19.2703 20.6803L16.6903 18.1003C16.0103 18.5203 15.2603 18.8503 14.4603 19.0603V16.9703C14.7203 16.8703 14.9703 16.7603 15.2203 16.6303L7.14031 8.55031C6.71031 9.38031 6.46031 10.3203 6.46031 11.3203C6.46031 12.9803 7.14031 14.4703 8.22031 15.5603L10.4603 13.3203V19.3203H4.46031L6.82031 16.9603C5.37031 15.5203 4.46031 13.5303 4.46031 11.3203C4.46031 9.76031 4.91031 8.31031 5.68031 7.09031L3.32031 4.73031ZM20.4603 11.3203C20.4603 9.11031 19.5503 7.12031 18.1003 5.68031L20.4603 3.32031H14.4603V9.32031L16.7003 7.08031C17.7803 8.17031 18.4603 9.66031 18.4603 11.3203C18.4603 12.1703 18.2703 12.9703 17.9503 13.7003L19.4503 15.2003C20.0903 14.0603 20.4603 12.7303 20.4603 11.3203ZM10.4601 5.67203V3.58203C9.80008 3.75203 9.17008 4.01203 8.58008 4.33203L10.0801 5.83203C10.1451 5.80703 10.2076 5.77953 10.2701 5.75203C10.3326 5.72453 10.3951 5.69703 10.4601 5.67203Z'
            fill='#696F88'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={OFFSVG} {...props} />;
};
export const RefreshIcon = (props: Partial<CustomIconComponentProps>) => {
  const RefreshSVG = () => {
    return (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='icon-left-24px'>
          <path
            id='cached'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12 6C8.69 6 6 8.69 6 12H9L5 16L1 12H4C4 7.58 7.58 4 12 4C13.57 4 15.03 4.46 16.26 5.24L14.8 6.7C13.97 6.25 13.01 6 12 6ZM15.0002 12L19.0002 8L23.0002 12H20.0002C20.0002 16.42 16.4202 20 12.0002 20C10.4302 20 8.97023 19.54 7.74023 18.76L9.20023 17.3C10.0302 17.75 10.9902 18 12.0002 18C15.3102 18 18.0002 15.31 18.0002 12H15.0002Z'
            fill='#696F88'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={RefreshSVG} {...props} />;
};

export const TrashIcon = (props: Partial<CustomIconComponentProps>) => {
  const TrashSVG = () => {
    return (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='delete'>
          <path
            id='icon/action/delete_24px'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM16 9V19H8V9H16ZM6 7H18V19C18 20.1 17.1 21 16 21H8C6.9 21 6 20.1 6 19V7Z'
            fill='#CF3537'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={TrashSVG} {...props} />;
};

export const DeleteIcon = (props: IconProps) => {
  const DeleteIconSVG = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM16 9V19H8V9H16ZM6 7H18V19C18 20.1 17.1 21 16 21H8C6.9 21 6 20.1 6 19V7Z'
          fill='#696F88'
        />
      </svg>
    );
  };
  return <Icon component={DeleteIconSVG} {...props} />;
};

export const DownloadIcon = () => {
  const DownloadSVG = () => {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='icon-right'>
          <path
            id='icon/action/get_app_24px'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M11.25 2.625H6.75V7.125H3.75L9 12.375L14.25 7.125H11.25V2.625ZM9.75006 4.125V8.625H10.6276L9.00006 10.2525L7.37256 8.625H8.25006V4.125H9.75006ZM3.75 15.375V13.875H14.25V15.375H3.75Z'
            fill='#696F88'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={DownloadSVG} />;
};

export const FileExportIcon = (props: Partial<CustomIconComponentProps>) => {
  const FileExportSVG = () => {
    return (
      <svg
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='icon-right'>
          <path
            id='icon/action/get_app_24px'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M11.25 2.625H6.75V7.125H3.75L9 12.375L14.25 7.125H11.25V2.625ZM9.75006 4.125V8.625H10.6276L9.00006 10.2525L7.37256 8.625H8.25006V4.125H9.75006ZM3.75 15.375V13.875H14.25V15.375H3.75Z'
            fill='#696F88'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={FileExportSVG} {...props} />;
};

export const AddUserIcon = (props) => {
  const AddUserIconSVG = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 18 18'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M11.25 9C12.9075 9 14.25 7.6575 14.25 6C14.25 4.3425 12.9075 3 11.25 3C9.5925 3 8.25 4.3425 8.25 6C8.25 7.6575 9.5925 9 11.25 9ZM11.25 4.5C12.075 4.5 12.75 5.175 12.75 6C12.75 6.825 12.075 7.5 11.25 7.5C10.425 7.5 9.75 6.825 9.75 6C9.75 5.175 10.425 4.5 11.25 4.5ZM5.25 13.5C5.25 11.505 9.2475 10.5 11.25 10.5C13.2525 10.5 17.25 11.505 17.25 13.5V15H5.25V13.5ZM6.75 13.5C6.915 12.96 9.2325 12 11.25 12C13.275 12 15.6 12.9675 15.75 13.5H6.75ZM4.5 9V11.25H3V9H0.75V7.5H3V5.25H4.5V7.5H6.75V9H4.5Z'
          fill='currentColor'
        />
      </svg>
    );
  };
  return <Icon component={AddUserIconSVG} {...props} />;
};
